import React, {Fragment, useEffect, useState} from "react";
import {Decimal} from 'decimal.js'
import PageHeaderLayout from "../../../../layout/pageHeaderLayout";
import {useHistory} from "react-router-dom";
import {useParams} from "react-router";
import {useRequest} from "ahooks";
import * as api from "../../../../apis/platforms/admin/financeWriteOff";
import {getFinanceReceiptDetail} from "../../../../apis/platforms/admin/financeReceipt"
import {
    Button,
    Card,
    Cascader,
    Col,
    Descriptions, Divider,
    Form,
    Input,
    InputNumber, message, Popconfirm,
    Row,
    Select,
    Space
} from "antd";
import dayjs from "dayjs";
import ProfileTitle from "../../../../components/ProfileTitle";
import {useForm} from "antd/lib/form/Form";
import OrderSelectModal from "./orderSelectModal";
import DatePicker from "../../../../components/DatePicker";
import withAuth from "../../../../utils/withAuth";
import {EditOutlined} from "@ant-design/icons";
import * as dgram from "dgram";

const EditFragmentFragment = withAuth('edit', Fragment)
const DeleteFragment = withAuth('delete', Popconfirm)
const ApproveFragment = withAuth('approve', Popconfirm)
const ApproveForceFragment = withAuth('approveForce', Popconfirm)
const CancelApproveFragment = withAuth('cancelApprove', Popconfirm)

export default function FinanceWriteOffDetail() {

    const history = useHistory()
    //获取 receiptId 或 writeOffId
    const {id, writeOffId} = useParams<any>()
    const [form] = useForm()
    //设置订单选择弹窗状态
    const [orderSelectModalVisible, setOrderSelectModalVisible] = useState(false)
    //该页面是否是新增
    const [addMode, setAddMode] = useState(true)
    const [canEdit, setCanEdit] = useState(true)
    //核销单详情
    const [writeOffDetail, setWriteOffDetail] = useState<any>()
    //收款单详情
    const [receiptDetail, setReceiptDetail] = useState<any>()
    //核销单行
    const [writeOffItem, setWriteOffItem] = useState<Array<any>>([])
    //当前核销总金额
    const [totalAmount, setTotalAmount] = useState(0)


    useEffect(() => {
        if (id) {
            getReceiptDetail(id)
        }
        if (writeOffId) {
            getWriteOffDetail(writeOffId)
            setAddMode(false)
            setCanEdit(false)
        }
    }, [])

    //获取收款单信息
    const {run: getReceiptDetail} = useRequest(getFinanceReceiptDetail, {
        manual: true,
        onSuccess: (res) => {
            setReceiptDetail(res.data.data)
        }
    })

    //获取核销单信息
    const {run: getWriteOffDetail} = useRequest(api.getWriteOffDetail, {
        manual: true,
        onSuccess: (res) => {
            setWriteOffDetail(res.data.data)
            setReceiptDetail(res.data.data.financeReceipt)
            setTotalAmount(res.data.data.writeOffItems.reduce((pre: any, next: any) => new Decimal(next.orderWriteOffAmount).add(pre), new Decimal(0)).toString())
            form.setFieldValue('order', res.data.data.writeOffItems.map((item: any) => {
                let writeOffAmount = 0
                if (item.refund) {
                    writeOffAmount = res.data.data.item.find((i: any) => item.refundId === i.refundId).writeOffAmount
                } else {
                    writeOffAmount = res.data.data.item.find((i: any) => item.saleOrderId === i.orderId).writeOffAmount
                }
                return {
                    ...item,
                    writeOffItemAmount: writeOffAmount,
                    writeOffAmount: writeOffAmount,
                    exist: true
                }
            }))
        }
    })

    //核销
    const {run: doWriteOff, loading: doWriteOffLoading} = useRequest(api.doWriteOff, {
        manual: true,
        onSuccess: (res) => {
            message.success("核销成功")
            history.push(`/finance/writeOff/detail/${res.data.data}`)
        }
    })

    //修改核销
    const {run: editWriteOff, loading: doEditWriteOffLoading} = useRequest(api.editWriteOff, {
        manual: true,
        onSuccess: (res) => {
            message.success("修改成功")
            getWriteOffDetail(writeOffId)
            setCanEdit(false)
        }
    })

    const {run: doDelete} = useRequest(api.deleteWriteOff, {
        manual: true,
        onSuccess: (res) => {
            message.success("删除成功")
            history.goBack()
        }
    })

    const {loading: approveLoading, run: doApprove} = useRequest(api.approveWriteOff, {
        manual: true,
        onSuccess: (res) => {
            message.success("成功")
            getWriteOffDetail(writeOffId)
        }
    })

    //完成订单选择
    function orderSelectComplete(keys: any, records: any) {
        let origin = form.getFieldValue(['order']).filter((i: any) => i)
        let existWriteOffAmountTotal = origin.filter(((item: any) => item.writeOffAmount)).reduce((pre: any, next: any) => Decimal.add(pre, next.writeOffAmount), 0)
        let receiptNoWriteOffAmount = Decimal.sub(receiptDetail.receiptAmount, receiptDetail.receiptWriteOffAmountTotal)
        if (!receiptNoWriteOffAmount.greaterThanOrEqualTo(existWriteOffAmountTotal)) {
            message.error("已达到收款单可核销金额上限")
            return
        }
        let spareAmount = receiptNoWriteOffAmount.sub(existWriteOffAmountTotal)
        const codeList = origin.map((i: any) => i.orderCode)
        const newRecords = records.filter((i: any) => {
            return !codeList.includes(i.orderCode)
        }).map((item: any) => {
            debugger
            let writeOffAmount = Decimal.sub(item.orderAmount, item.orderWriteOffAmount)
            const amount = Decimal.min(spareAmount, item.unpaidAmount)
            spareAmount = spareAmount.minus(amount)
            item.writeOffAmount = amount.toNumber()
            return item
        }).filter((item: any) => item.writeOffAmount > 0)
        origin = [...origin, ...newRecords]
        const result = origin.filter((item: any) => item.orderCode != null)
        result.forEach((item: any, index: number) => {
            form.setFieldValue(['order', index, 'saleOrderId'], item.saleOrderId)
            form.setFieldValue(['order', index, 'refundId'], item.refundId)
            form.setFieldValue(['order', index, 'orderCode'], item.orderCode)
            form.setFieldValue(['order', index, 'orderDate'], item.orderDate)
            form.setFieldValue(['order', index, 'dateOfReceivable'], item.dateOfReceivable)
            form.setFieldValue(['order', index, 'orderAmount'], item.orderAmount)
            form.setFieldValue(['order', index, 'orderWriteOffAmount'], item.orderWriteOffAmount)
            form.setFieldValue(['order', index, 'writeOffAmount'], item.writeOffAmount)
        })
        setOrderSelectModalVisible(false)
    }

    //提交核销
    function doSubmit() {
        form.validateFields().then((res) => {
            let target = res.order.reduce((pre: any, next: any) => Decimal.add(pre, next.writeOffAmount), 0)
            let source = Decimal.sub(receiptDetail.receiptAmount, receiptDetail.receiptWriteOffAmountTotal)
            if (!source.greaterThanOrEqualTo(new Decimal(target))) {
                debugger
                message.error("核销金额大于可核销总金额")
                return
            }
            doWriteOff({
                receiptId: receiptDetail.id,
                order: res.order.map((i: any) => {
                    return {
                        type: i.saleOrderId !== null ? 0 : 1,
                        orderId: i.saleOrderId ? i.saleOrderId : null,
                        refundId: i.refundId ? i.refundId : null,
                        writeOffAmount: i.writeOffAmount
                    }
                })
            })
        })
    }

    function doEdit() {
        form.validateFields().then((res) => {
            let target = res.order.reduce((pre: any, next: any) => pre + next.writeOffAmount, 0)
            let source = receiptDetail.receiptAmount - receiptDetail.receiptWriteOffAmountTotal
            if (target > source) {
                message.error("核销金额大于可核销总金额")
                return
            }
            editWriteOff({
                receiptId: receiptDetail.id,
                writeOffId: writeOffDetail.id,
                order: res.order.map((i: any) => {
                    return {
                        type: i.saleOrderId !== null ? 0 : 1,
                        orderId: i.saleOrderId ? i.saleOrderId : null,
                        refundId: i.refundId ? i.refundId : null,
                        writeOffAmount: i.writeOffAmount
                    }
                })
            })
        })
    }

    //计算总核销金额
    function calculate() {
        setTotalAmount(form.getFieldsValue().order.reduce((pre: any, next: any) => new Decimal(next.writeOffAmount).add(pre), new Decimal(0)).toString())
    }

    return (
        <PageHeaderLayout withFooterBar={canEdit} onOk={addMode ? doSubmit : doEdit}
                          btnLoading={doWriteOffLoading && doEditWriteOffLoading}
                          onCancel={() => {
                              setCanEdit(false)
                              getWriteOffDetail(writeOffId)
                          }}>
            <Card title={
                !addMode && writeOffDetail && <Space>
                    <p>核销人：<span style={{color: "orange"}}>{writeOffDetail.createName}</span></p>
                    <p>审核人：<span
                        style={{color: "orange"}}>{writeOffDetail.reviewedUserName ? writeOffDetail.reviewedUserName : '暂未审核'}</span>
                    </p>
                    <p>审核时间：<span
                        style={{color: "orange"}}>{writeOffDetail.reviewedDate ? dayjs(writeOffDetail.reviewedDate).format('ll') : '暂未审核'}</span>
                    </p>
                </Space>
            } extra={
                !addMode && <Space split={<Divider type="vertical"/>} style={{fontWeight: "bold"}}>
                    {writeOffDetail && writeOffDetail.status === 0 &&
                        <>
                            <EditFragmentFragment>
                                <a onClick={() => setCanEdit(true)}>修改</a>
                            </EditFragmentFragment>
                            <DeleteFragment
                                title="确认删除"
                                description="此操作将删除该核销单并不可恢复"
                                onConfirm={() => doDelete(writeOffDetail.id)}
                                okText="确认删除"
                                cancelText="取消"
                                placement="bottomRight"
                            >
                                <a>删除</a>
                            </DeleteFragment>
                        </>
                    }
                    {writeOffDetail && writeOffDetail.status === 0 ?
                        <>
                            <ApproveFragment
                                title="确认审核"
                                description="此操作将对该核销单进行审核"
                                onConfirm={() => {
                                    message.info("销售订单正在处理中...")
                                    doApprove(writeOffDetail.id)
                                }}
                                okText="确认审核"
                                cancelText="取消"
                                placement="bottomRight"
                            >
                                <Button type={"link"} loading={approveLoading}>审核</Button>
                            </ApproveFragment>

                            <ApproveForceFragment
                                title="强制审核"
                                description="此操作将忽略ERP同步，直接审核"
                                onConfirm={() => {
                                    message.info("销售订单正在处理中...")
                                    doApprove(writeOffDetail.id, true)
                                }}
                                okText="确认审核"
                                cancelText="取消"
                                placement="bottomRight"
                            >
                                <Button type={"link"} loading={approveLoading}>强制审核</Button>
                            </ApproveForceFragment>
                        </> :
                        <CancelApproveFragment
                            title="取消审核"
                            description="此操作将取消对该核销单的审核记录"
                            onConfirm={() => doApprove(writeOffDetail.id)}
                            okText="取消审核"
                            cancelText="取消"
                            placement="bottomRight"
                        >
                            <a>取消审核</a>
                        </CancelApproveFragment>

                    }
                    <a onClick={() => history.goBack()}>返回</a>
                </Space>
            }>
                {receiptDetail && (
                    <Descriptions size={'middle'} bordered title="基本信息" column={3}>
                        <Descriptions.Item
                            label="核销单号">{writeOffDetail ? writeOffDetail.writeOffNo : '自动生成'}</Descriptions.Item>
                        <Descriptions.Item label="客户">{receiptDetail.dealerName}</Descriptions.Item>
                        <Descriptions.Item
                            label="核销时间">{writeOffDetail ? dayjs(writeOffDetail.writeOffDate).format('ll') : dayjs().format('ll')}</Descriptions.Item>
                    </Descriptions>
                )}
                {receiptDetail && (
                    <Descriptions style={{marginTop: 20}} size={'middle'} layout={'vertical'} bordered
                                  title="收款单列表" column={6}>
                        <Descriptions.Item label="收款编号">{receiptDetail.receiptNo}</Descriptions.Item>
                        <Descriptions.Item
                            label="收款日期">{dayjs(receiptDetail.receiptDate).format('ll')}</Descriptions.Item>
                        <Descriptions.Item label="付款说明">{receiptDetail.paymentDesc}</Descriptions.Item>
                        <Descriptions.Item label="核销状态">
                            {receiptDetail.writeOffStatus === 0 ? '未核销' : receiptDetail.writeOffStatus === 10 ? '部分核销' : '已核销'}
                        </Descriptions.Item>
                        <Descriptions.Item label="收款金额">{receiptDetail.receiptAmount}</Descriptions.Item>
                        <Descriptions.Item label="未核销金额">
                            {Decimal.sub(receiptDetail.receiptAmount, receiptDetail.receiptWriteOffAmountTotal).toString()}
                        </Descriptions.Item>
                    </Descriptions>
                )}
                <div style={{marginTop: 20, marginBottom: 20}}>
                    <div style={{display: "flex", flexDirection: "row", justifyContent: "space-between"}}>
                        <ProfileTitle>订单列表</ProfileTitle>
                        <Space style={{color: "red"}}>
                            <h4>本次核销总金额：<h2 style={{display: "inline"}}>{totalAmount}</h2></h4>
                            <h4>尚未核销订单总金额：<h2
                                style={{display: "inline"}}>{receiptDetail && receiptDetail.dealerNoWriteOffAmountTotal}</h2>
                            </h4>
                        </Space>
                    </div>
                    <Form form={form} disabled={!canEdit}>
                        <Row gutter={10} style={{marginBottom: 10, textAlign: "center"}}>
                            <Col span={2}/>
                            <Col span={4}>订单号</Col>
                            <Col span={4}>订单日期</Col>
                            <Col span={3}>应收款日期</Col>
                            <Col span={3}>订单金额</Col>
                            <Col span={4}>已核销金额</Col>
                            <Col span={4}>本次核销</Col>
                        </Row>
                        <Form.List name={'order'} initialValue={[{}]}>
                            {(fields, {add, remove}) => (
                                <>
                                    {
                                        fields.map(field => (
                                            <Row gutter={10}>
                                                <Col key={field.key} span={2}>
                                                    {canEdit && <Space>
                                                        <Space>
                                                            <Button onClick={() => add()}>+</Button>
                                                            <Button onClick={() => {
                                                                remove(field.name)
                                                            }}>-</Button>
                                                        </Space>
                                                    </Space>}
                                                </Col>
                                                <Col span={4}>
                                                    <Row gutter={4}>
                                                        <Col span={17}>
                                                            <Form.Item name={[field.name, 'exist']} noStyle/>
                                                            <Form.Item name={[field.name, 'saleOrderId']} noStyle/>
                                                            <Form.Item name={[field.name, 'refundId']} noStyle/>
                                                            <Form.Item name={[field.name, 'writeOffItemAmount']}
                                                                       noStyle/>
                                                            <Form.Item name={[field.name, 'orderCode']}
                                                                       rules={[{
                                                                           required: true,
                                                                           message: '请选择订单'
                                                                       }]}>
                                                                <Input disabled={true}
                                                                       style={{width: '100%'}}/>
                                                            </Form.Item>
                                                        </Col>
                                                        <Col span={5}>
                                                            <Form.Item noStyle
                                                                       dependencies={[['order', field.name, 'orderAmount'], ['order', field.name, 'orderWriteOffAmount'], ['order', field.name, 'exist']]}>
                                                                {({getFieldValue}) => {
                                                                    const disable = getFieldValue(['order', field.name, 'exist'])
                                                                    return <Button disabled={disable} onClick={() => {
                                                                        setOrderSelectModalVisible(true)
                                                                    }}>
                                                                        选择
                                                                    </Button>
                                                                }
                                                                }
                                                            </Form.Item>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                                <Col span={4}>
                                                    <Form.Item name={[field.name, 'orderDate']}>
                                                        <DatePicker disabled={true} style={{width: '100%'}}/>
                                                    </Form.Item>
                                                </Col>
                                                <Col span={3}>
                                                    <Form.Item name={[field.name, 'dateOfReceivable']}>
                                                        <DatePicker disabled={true} style={{width: '100%'}}/>
                                                    </Form.Item>
                                                </Col>
                                                <Col span={3}>
                                                    <Form.Item name={[field.name, 'orderAmount']}>
                                                        <Input disabled={true} style={{width: '100%'}}/>
                                                    </Form.Item>
                                                </Col>
                                                <Col span={4}>
                                                    <Form.Item name={[field.name, 'orderWriteOffAmount']}>
                                                        <Input disabled={true} style={{width: '100%'}}/>
                                                    </Form.Item>
                                                </Col>
                                                <Col span={4}>
                                                    <Form.Item noStyle
                                                               dependencies={[['order', field.name, 'orderAmount'], ['order', field.name, 'orderWriteOffAmount'], ['order', field.name, 'exist']]}>
                                                        {({getFieldValue}) => {
                                                            const orderAmount = getFieldValue(['order', field.name, 'orderAmount'])
                                                            const orderWriteOffAmount = getFieldValue(['order', field.name, 'orderWriteOffAmount'])
                                                            const writeOffItemAmount = getFieldValue(['order', field.name, 'writeOffItemAmount'])
                                                            let maxWriteOffAmount = 0
                                                            if (addMode) {
                                                                maxWriteOffAmount = orderAmount - orderWriteOffAmount
                                                            } else {
                                                                maxWriteOffAmount = orderAmount - orderWriteOffAmount + writeOffItemAmount
                                                            }
                                                            return (
                                                                <Form.Item name={[field.name, 'writeOffAmount']}
                                                                           rules={[{
                                                                               required: true,
                                                                               message: '请输入核销金额'
                                                                           }]}>
                                                                    <InputNumber onChange={calculate}
                                                                                 max={maxWriteOffAmount}
                                                                                 min={0.01}
                                                                                 style={{width: '100%'}}/>
                                                                </Form.Item>
                                                            )
                                                        }
                                                        }
                                                    </Form.Item>

                                                </Col>
                                            </Row>
                                        ))
                                    }
                                    {fields.length > 0 ? null : <Button onClick={() => add()}>+</Button>}
                                </>
                            )}
                        </Form.List>
                    </Form>
                </div>
            </Card>
            <OrderSelectModal width={1000} open={orderSelectModalVisible}
                              dealerId={receiptDetail ? receiptDetail.dealerId : null}
                              onCancel={() => setOrderSelectModalVisible(false)}
                              title={'订单选择'} onComplete={(keys, records) => orderSelectComplete(keys, records)}
                              destroyOnClose={true}/>
        </PageHeaderLayout>
    )
}
